const random = (array) => {
  return array[Math.round(Math.random() * (array.length - 0.5))];
};

export default random;
